module.exports = __webpack_public_path__ + "static/media/add_bundle.fa9c6fbd.svg";